<script lang="ts"> 
  import { Button, Col} from "sveltestrap";
  import { BuyNow, discription5, href, WomenPinkshirt } from "../../../../utils/Constant/Constant";
  import Card from "../../../Core/Card.svelte";
  import ShareIt from "./ShareIt.svelte";
  import ProductTable from "./ProductTable.svelte";
  import StarRating from 'svelte-star-rating';
  import ProductButton from "./ProductButton.svelte";
</script>
<Col xxl="5" class="box-col-6 proorder-xl-3 xl-100">
    <Card>
      <div slot="contentbody">
        <div class="pro-group pt-0 border-0">
            <div class="product-page-details mt-0">
                <h3>{WomenPinkshirt}</h3>
                <div class="pro-review">
                    <div class="d-flex">
                        <StarRating rating={4}  />
                        <span>{'(250 review)'}</span>
                    </div>
                </div>
            </div>
            <div class="product-price">$26.00  
                <del>$350.00 </del>
            </div>
            <ul class="product-color">
                <li class="bg-primary"></li>
                <li class="bg-secondary"></li>
                <li class="bg-success"></li>
                <li class="bg-danger"></li>
                <li class="bg-info"></li>
                <li class="bg-warning"></li>
            </ul>
            <Button color="secondary" class="mt-0" href={href}>
                <i class="fa fa-shopping-cart me-2"></i>{BuyNow}
            </Button>
        </div>
        <div class="pro-group">
            <p>{discription5}</p>
        </div>
        <ProductTable />
        <ShareIt />
        <ProductButton />
      </div>
    </Card>
</Col>